import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import Voice from "./Voice";

var Noise =
/*#__PURE__*/
function (_Voice) {
  _inherits(Noise, _Voice);

  function Noise(context, gain) {
    var _this;

    _classCallCheck(this, Noise);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Noise).call(this, context, gain));
    _this._length = 2;
    return _this;
  }

  _createClass(Noise, [{
    key: "init",
    value: function init() {
      var lBuffer = new Float32Array(this.length * this.context.sampleRate);
      var rBuffer = new Float32Array(this.length * this.context.sampleRate);

      for (var i = 0; i < this.length * this.context.sampleRate; i++) {
        lBuffer[i] = 1 - 2 * Math.random();
        rBuffer[i] = 1 - 2 * Math.random();
      }

      var buffer = this.context.createBuffer(2, this.length * this.context.sampleRate, this.context.sampleRate);
      buffer.copyToChannel(lBuffer, 0);
      buffer.copyToChannel(rBuffer, 1);
      var osc = this.context.createBufferSource();
      osc.buffer = buffer;
      osc.loop = true;
      osc.loopStart = 0;
      osc.loopEnd = 2;
      osc.start(this.context.currentTime);
      osc.connect(this.ampEnvelope.output);
      this.partials.push(osc);
    }
  }, {
    key: "on",
    value: function on(MidiEvent) {
      this.value = MidiEvent.value;
      this.ampEnvelope.on(MidiEvent.velocity || MidiEvent);
    }
  }, {
    key: "length",
    get: function get() {
      return this._length || 2;
    },
    set: function set(value) {
      this._length = value;
    }
  }]);

  return Noise;
}(Voice);

export { Noise as default };